import type { BookingDetails } from 'app/typings/core/extranet/bookings/booking';
import { formatDayMonthWithHoursMinutes } from 'app/utils/dates';
import { formatPaxAsString } from 'app/utils/pax';

import { RenderInfo } from '../../../../../common/RenderInfo/RenderInfo';

import styles from './BookingInfo.module.scss';

type BookingInfoProps = {
  bookingDetails: BookingDetails;
};

const BOOKING_INFO_FIELDS = [
  {
    title: 'Guests',
    getValue: (b: BookingDetails) =>
      formatPaxAsString({
        adults: b.adults,
        children: b.children,
        babies: b.babies,
      }),
  },
  {
    title: 'Check-in',
    getValue: (b: BookingDetails) => formatDayMonthWithHoursMinutes(b.checkIn),
  },
  {
    title: 'Check-out',
    getValue: (b: BookingDetails) => formatDayMonthWithHoursMinutes(b.checkOut),
  },
  {
    title: 'Booking ID',
    getValue: (b: BookingDetails) => b.code,
  },
  {
    title: 'Phone number',
    getValue: (b: BookingDetails) => b.customerData.phone,
  },
  {
    title: 'Email address',
    getValue: (b: BookingDetails) => b.customerData.email,
    isVisible: (b: BookingDetails) => b.pack.isDaytime,
    className: styles.newRow,
  },
] as const;

export const BookingInfo = ({ bookingDetails }: BookingInfoProps) => (
  <div className={styles.bookingInfoGrid}>
    {BOOKING_INFO_FIELDS.filter(
      (field) => !('isVisible' in field) || field.isVisible(bookingDetails)
    ).map((field) => (
      <div
        key={field.title}
        className={'className' in field ? field.className : undefined}
      >
        <RenderInfo
          title={field.title}
          content={field.getValue(bookingDetails) ?? '-'}
        />
      </div>
    ))}
  </div>
);
